import { settingsApi } from '@/admin/api/settings';
import { queryOptions } from '@tanstack/react-query';

export const settingsQuery = () =>
	queryOptions({
		queryKey: ['settings'] as const,
		queryFn: settingsApi.get,
		staleTime: 5 * 60_000,
		gcTime: 10 * 60_000,
		refetchOnWindowFocus: false,
	});
